// extracted by mini-css-extract-plugin
module.exports = {"root":"HighlightsBar_root__7aSL8","secondary":"HighlightsBar_secondary__2ciKZ","plaa":"HighlightsBar_plaa__b0m7K","wrapper":"HighlightsBar_wrapper__33_7o"};